import { IDashboardRepository } from '../../domain/repositories/IDashboardRepository';
import { NotificationDTO } from '../dto/NotificationDTO';
import { DashboardMapper } from '../mappers/DashboardMapper';

/**
 * Get Notifications Use Case
 * Retrieves recent notifications for a specific user role
 */
export class GetNotificationsUseCase {
  constructor(private dashboardRepository: IDashboardRepository) {}

  async execute(role: string): Promise<NotificationDTO[]> {
    const notifications = await this.dashboardRepository.getNotifications(role);
    return DashboardMapper.notificationToDTOList(notifications);
  }
}
